
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contato",
      function () {
        return require("private-next-pages/contato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contato"])
      });
    }
  